<template>
    <div class="materialBox">
        <div class="title">
            <p ></p>
            <h4>上传财保保全申请书、送达地址确认书、网络查控申请书</h4>
        </div>
        <p style="color: red;margin: 20px">上传保全申请书、送达地址确认书、网络查控申请书前请务必检查是否在日期上边或下边设置了签章关键字sign0001，关键字sign0001字体需设置为白色，否则无法正常盖章(关键字字母均为小写)。</p>

        <!-- *************************************************** 财保保全申请书 *********************************************************************   -->
        <div class="matter">
            <div class="fileContent">
                <p>财保保全申请书:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="1"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="application"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        ***********************************************************送达地址确认书***********************************************************-->
        <div class="matter">
            <div class="fileContent">
                <p>送达地址确认书:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="1"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="address_data"
                    :file-list="addressList"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        *********************************************************网络查控申请书*************************************************************-->
        <div class="matter">
            <div class="fileContent">
                <p>网络查控申请书:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="1"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="check_data"
                    :file-list="checkList"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        保存-->
        <div class="preserve">
            <el-button @click="saveFileBtn">保存文件</el-button>
        </div>
<!--        *********************************************************上传线索材料**************************************************************-->
        <clueMaterial :showList="showList"></clueMaterial>
    </div>
</template>

<script>
    import clueMaterial from './clueMaterial'
    import { fileDetails, saveSignFile } from '../../../api/insure';
    export default {
        name: 'uploadMaterial',
        inject:['reload'],
        components:{
            clueMaterial
        },
        data(){
          return{
              url:process.env.VUE_APP_BASE_API+'/api/upload_baquan_dizhi_file', //上传地址
              headers:{
                  "Authorization": sessionStorage.getItem("token")
              },
              //财保保全申请书
              upload_data:{
                  case_id:'',
                  doc_type:'67'   //67财产保全申请书；68送达地址确认书；74网络查控申请书
              },
              propertyInsurance:{
                  doc_type:'67', //67财产保全申请书；68送达地址确认书；74网络查控申请书
                  psd_code:'',
              },
              //送达地址确认书
              address_data:{
                  case_id:'',
                  doc_type:'68'    //67财产保全申请书；68送达地址确认书；74网络查控申请书
              },
              address_form:{
                  doc_type:'68', //67财产保全申请书；68送达地址确认书；74网络查控申请书
                  psd_code:'',
              },
              //网络查控申请书
              check_data:{
                  case_id:'',
                  doc_type:'74'    //67财产保全申请书；68送达地址确认书；74网络查控申请书
              },
              check_form:{
                  doc_type:'74', //67财产保全申请书；68送达地址确认书；74网络查控申请书
                  psd_code:'',
              },
              application:[], //财保保全申请书
              addressList:[], //送达地址确认书
              checkList:[],  //网络查控申请书
              showList:'', //展示列表
          }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //删除
            applicationRemove(){

            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    if (response.data.doc_type==67){
                        this.propertyInsurance.psd_code=response.data.psd_code
                    }else if (response.data.doc_type==68){
                        this.address_form.psd_code=response.data.psd_code
                    }else if (response.data.doc_type==74){
                        this.check_form.psd_code=response.data.psd_code
                    }
                    this.$message.success(response.msg)
                }else {
                    this.$message.error(response.msg)
                }
            },
            //限制上传条数
            handleExceed(files, fileList){
                if (fileList.length>=1){
                    this.$message.error('只能上传1个文件');
                }
            },
            //保存文件
            saveFileBtn(){
                let data={
                    case_id:this.$route.query.id,
                    baoquansqshu:this.propertyInsurance,
                    songdadzqrshu:this.address_form,
                    wangluochakong:this.check_form
                }
                saveSignFile(data).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        // this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            this.upload_data.case_id=this.$route.query.id
            this.address_data.case_id=this.$route.query.id
            this.check_data.case_id=this.$route.query.id

            fileDetails({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.showList=res
                    if (res.data.baoquansqshu!=''&&res.data.baoquansqshu!=undefined){
                        this.application.push({name:res.data.baoquansqshu.name,all_url:res.data.baoquansqshu.all_url})
                    }
                    if (res.data.songdadzqrshu!=''&&res.data.songdadzqrshu!=undefined){
                        this.addressList.push({name:res.data.songdadzqrshu.name,all_url:res.data.songdadzqrshu.all_url})
                    }
                    if (res.data.wangluochakong!=''&&res.data.wangluochakong!=undefined){
                        this.checkList.push({name:res.data.wangluochakong.name,all_url:res.data.wangluochakong.all_url})
                    }
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .materialBox{
        padding: 30px;
        background-color: #ffffff;
        min-width: 95% !important;
        width: max-content;
        border-radius: 5px;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3e62f6;
        margin-bottom: 20px;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3e62f6;
        margin-right: 10px;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 10px 25px;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    /deep/.el-input__inner{
        color: #878889 !important;
    }
    /deep/.el-form-item__content{
        height: 32px;
        align-items: center;
    }
    /deep/.el-form-item__content{
        display: flex;
    }
    /deep/.el-input--small,
    /deep/.el-input__inner{
        width: 250px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve{
        width: 100%;
        text-align: center;
    }
    .preserve>button{
        background-color: #3e62f6;
        color: #ffffff;
    }
    .fileContent{
        width: 120px;
    }
</style>
